import Content from "./Content";
import VariableMutation from "./VariableMutation";

export default class SetVariableContent extends Content {

    constructor(languagePack, contentID, label) {
        super(SetVariableContent.NAME, SetVariableContent.TYPE, label, languagePack, contentID);
        this.variableMutations = [];
    }

    getVariableMutations() {
        var variableNames = this.getLanguagePackContent(SetVariableContent.VARIABLE_NAMES_LABEL, SetVariableContent.TYPE);
        var mutationTypes = this.getLanguagePackContent(SetVariableContent.MUTATION_TYPES_LABEL, SetVariableContent.TYPE);
        var values = this.getLanguagePackContent(SetVariableContent.VALUES_LABEL, SetVariableContent.TYPE);
        variableNames = (variableNames === null) ? [] : variableNames;
        mutationTypes = (mutationTypes === null) ? [] : mutationTypes;
        values = (values === null) ? [] : values;
        var numMutations = variableNames.length;
        var variableMutations = [];

        var variableMutation;
        for (var index = 0; index < numMutations; index++) {
            variableMutation = new VariableMutation(variableNames[index], mutationTypes[index], values[index]);
            variableMutations.push(variableMutation);
        }
        return variableMutations;
    };

    setVariableMutations(value) {
        var variableNames = [];
        var mutationTypes = [];
        var values = [];
        var numVariableMutations = value.length;

        var variableMutation;
        for (var index = 0; index < numVariableMutations; index++) {
            variableMutation = value[index];
            variableNames.push(variableMutation.variableName);
            mutationTypes.push(variableMutation.mutationType);
            values.push(variableMutation.value);
        }

        this.setLanguagePackContent(SetVariableContent.VARIABLE_NAMES_LABEL, SetVariableContent.TYPE, variableNames);
        this.setLanguagePackContent(SetVariableContent.MUTATION_TYPES_LABEL, SetVariableContent.TYPE, mutationTypes);
        this.setLanguagePackContent(SetVariableContent.VALUES_LABEL, SetVariableContent.TYPE, values);
    };

    remove() {
        this.variableMutations = [];
    };

    convertToObject() {
        return this.getObject([]);
    };
}

SetVariableContent.NAME = "Set Variable";
SetVariableContent.TYPE = "engSetVariableContent";
SetVariableContent.VARIABLE_NAMES_LABEL = "variableNames";
SetVariableContent.MUTATION_TYPES_LABEL = "mutationTypes";
SetVariableContent.VALUES_LABEL = "values";
